import EventCard from './EventCard';
import styles from './EventList.module.css';

const EventList = ({
  events,
  variant = "grid",
  isOwner = false,
  userId = null,
  profileRole = null,
  allowEdit = true,
  showCheckinButton = false,
  showMemoriesButton = false,
}) => (
  <div className={variant === "carousel" ? styles.carousel : styles.cardList}>
    {events.map(event => (
      <EventCard
        key={event.id}
        event={event}
        isOwner={isOwner}
        userId={userId}
        profileRole={profileRole}
        allowEdit={allowEdit}
        showCheckinButton={showCheckinButton}
        showMemoriesButton={showMemoriesButton}
        variant={variant}
      />
    ))}
  </div>
);

export default EventList;
